/* eslint-disable no-nested-ternary */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useCallback, useState, KeyboardEvent } from "react";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { useHistory } from "react-router-dom";

import {
  ResultadoConsultaCelular,
  ResultadoDaConsulta,
  ResultadoConsultaCivil,
  ResultadoConsultaCriminal,
  ResultadoConsultaVeiculoPlaca,
  ResultadoConsultaCarcerario,
  // ResultadoConsultaMandado,
  ResultadoConsultaBike,
} from "../../../components/ConsultasIntegrada";
import {
  celularStoreImei,
  celularStoreNome,
  bikeStore,
  veiculoStorePlaca,
  veiculoStoreChassi,
  civilStoreNominal,
  civilStoreCPF,
  civilStoreRG,
  criminalStoreNominal,
  criminalStoreCPF,
  carcerarioStoreNominal,
  carcerarioStoreRG,
  // mandadoStoreNominal,
} from "../../../hooks/store";

import { LayoutConsultasIntegradas } from "./LayoutConsultasIntegradas";
import { useAuth } from "../../../hooks/auth";

const urls = {
  celular: null,
  civil: null,
  criminal: null,
  carcerario: null,
  // mandado: null,
  veiculo: null,
} as { [key: string]: string | null };

export const ConsultasIntegradas: React.FC = () => {
  const history = useHistory();
  const [placa, setPlaca] = useState("");
  const [chassiBike, setChassiBike] = useState("");
  const [chassiVeiculo, setChassiVeiculo] = useState("");
  const [imei, setImei] = useState("");
  const [rg, setRg] = useState("");
  // const [rc, setRc] = useState('')
  const [cpf, setCpf] = useState("");
  const [nome, setNome] = useState("");
  const [nomeMae, setNomeMae] = useState("");
  const [nomePai, setNomePai] = useState("");
  const [vulgo, setVulgo] = useState("");

  const [checkedPlaca, setCheckedPlaca] = useState(true);
  const [checkedImei, setCheckedImei] = useState(true);
  const [checkedCivil, setCheckedCivil] = useState(true);
  const [checkedCriminal, setCheckedCriminal] = useState(true);
  const [checkedCarcerario, setCheckedCarcerario] = useState(true);
  // const [checkedMandado, setCheckedMandado] = useState(true);

  const { user } = useAuth();

  const sistemas = user?.sistemas;
  sistemas?.forEach((sistema) => {
    switch (sistema.id_sistema) {
      case 1:
        urls.celular = sistema.url;
        break;
      case 2:
        urls.civil = sistema.url;
        break;
      // case 3:
      //   urls.mandado = sistema.url;
      //   break;
      case 4:
        urls.carcerario = sistema.url;
        break;
      case 8:
        urls.veiculo = sistema.url;
        break;
      case 9:
        urls.criminal = sistema.url;
        break;
      default:
        break;
    }
  });

  const {
    consultaVeiculoPlaca,
    resultadoVeiculoPlaca,
    limparConsultaVeiculoPlaca,
  } = veiculoStorePlaca((state) => state.veiculo);

  const {
    consultaVeiculoChassi,
    resultadoVeiculoChassi,
    limparConsultaVeiculoChassi,
  } = veiculoStoreChassi((state) => state.veiculo);

  const {
    consultaCelularImei,
    limparConsultaCelularImei,
    resultadoCelularImei,
  } = celularStoreImei((state) => state.celular);

  const {
    consultaCelularNome,
    limparConsultaCelularNome,
    resultadoCelularNome,
  } = celularStoreNome((state) => state.celular);

  const { consultaBikes, resultadoBike, limparConsultaBike } = bikeStore(
    (state) => state.bike
  );

  const {
    consultaCivilRg,
    resultadoCivilRg,
    limparConsultaCivilRg,
  } = civilStoreRG((state) => state.civil);

  const {
    consultaCivilCPF,
    resultadoCivilCPF,
    limparConsultaCivilCPF,
  } = civilStoreCPF((state) => state.civil);

  const {
    consultaCivilNominal,
    limparConsultaCivilNominal,
    resultadoCivilNominal,
  } = civilStoreNominal((state) => state.civil);

  const {
    consultaCriminalNominal,
    limparConsultaCriminalNominal,
    resultadoCriminalNominal,
  } = criminalStoreNominal((state) => state.criminal);

  const {
    consultaCriminalCPF,
    limparConsultaCriminalCPF,
    resultadoCriminalCPF,
  } = criminalStoreCPF((state) => state.criminal);

  const {
    consultaCarcerarioNominal,
    resultadoCarcerarioNominal,
    limparConsultaCarcerarioNominal,
  } = carcerarioStoreNominal((state) => state.carcerario);

  const {
    consultaCarcerarioRG,
    resultadoCarcerarioRG,
    limparConsultaCarcerarioRG,
  } = carcerarioStoreRG((state) => state.carcerario);

  // const {
  //   consultaMandadoNominal,
  //   resultadoMandadoNominal,
  //   limparConsultaMandadoNominal,
  // } = mandadoStoreNominal((state) => state.mandado);

  const { loading: loadingPlaca } = veiculoStorePlaca((state) => state.global);
  const { loading: loadingBike } = bikeStore((state) => state.global);
  const { loading: loadingCelular } = celularStoreImei((state) => state.global);
  const { loading: loadingCelNome } = celularStoreNome((state) => state.global);
  const { loading: loadingCivil } = civilStoreNominal((state) => state.global);
  const { loading: loadingCriminal } = criminalStoreNominal(
    (state) => state.global
  );

  const handleConsultaPlaca = () => setCheckedPlaca(!checkedPlaca);
  const handleConsultaImei = () => setCheckedImei(!checkedImei);
  const handleConsultaCivil = () => setCheckedCivil(!checkedCivil);
  const handleConsultaCriminal = () => setCheckedCriminal(!checkedCriminal);
  const handleConsultaCarcerario = () =>
    setCheckedCarcerario(!checkedCarcerario);
  // const handleConsultaMandado = () =>
  //   setCheckedMandado(!checkedMandado);
  function ConsultaVeiculo() {
    if (checkedPlaca && urls.veiculo) {
      if (placa.length > 6) consultaVeiculoPlaca(urls.veiculo, placa);

      if (chassiVeiculo.length > 8)
        consultaVeiculoChassi(urls.veiculo, chassiVeiculo);
    }
  }

  function ConsultaImei() {
    if (checkedImei && urls.celular && imei.length === 15)
      consultaCelularImei(urls.celular, imei);

    if (checkedImei && urls.celular) consultaCelularNome(urls.celular, nome);
  }

  function ConsultaBike() {
    if (checkedImei && urls.celular && chassiBike.length > 3)
      consultaBikes(urls.celular, chassiBike);
  }

  function ConsultaCivil() {
    if (checkedCivil && urls.civil) {
      if (cpf.length === 11) consultaCivilCPF(urls.civil, cpf);

      if (nome || nomeMae || nomePai)
        consultaCivilNominal(
          urls.civil,
          nome === "" ? undefined : nome,
          nomeMae === "" ? undefined : nomeMae,
          nomePai === "" ? undefined : nomePai
        );

      if (rg.length > 4) consultaCivilRg(urls.civil, rg);
    }
  }

  function ConsultaCriminal() {
    if (checkedCriminal && urls.criminal) {
      if (cpf.length === 11) consultaCriminalCPF(urls.criminal, cpf);

      if (nome || nomeMae || nomePai)
        consultaCriminalNominal(
          urls.criminal,
          nome === "" ? undefined : nome,
          nomeMae === "" ? undefined : nomeMae,
          nomePai === "" ? undefined : nomePai
        );
    }
  }

  function ConsultaCarceraria() {
    if (checkedCarcerario && urls.carcerario) {
      if (rg.length > 4) consultaCarcerarioRG(urls.carcerario, rg);

      if (nome || vulgo || nomeMae || nomePai)
        consultaCarcerarioNominal(
          urls.carcerario,
          nome === "" ? undefined : nome,
          vulgo === "" ? undefined : vulgo,
          nomeMae === "" ? undefined : nomeMae,
          nomePai === "" ? undefined : nomePai
        );
    }
  }

  // function ConsultaMandado() {
  //   if (checkedMandado && urls.mandado) {
  //     if (nome || vulgo || nomeMae || nomePai)
  //       consultaMandadoNominal(
  //         urls.mandado,
  //         nome === "" ? undefined : nome,
  //         vulgo === "" ? undefined : vulgo,
  //         nomeMae === "" ? undefined : nomeMae,
  //         nomePai === "" ? undefined : nomePai
  //       );
  //   }
  // }

  const keyBoardClick = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      e.key === "Enter" && ConsultaImei();
      e.key === "Enter" && ConsultaBike();
      e.key === "Enter" && ConsultaCivil();
      e.key === "Enter" && ConsultaCriminal();
      e.key === "Enter" && ConsultaVeiculo();
      e.key === "Enter" && ConsultaCarceraria();
      // e.key === "Enter" && ConsultaMandado();
    },
    [
      placa,
      chassiBike,
      chassiVeiculo,
      imei,
      rg,
      cpf,
      nome,
      nomeMae,
      nomePai,
      vulgo,
    ]
  );

  const handleRedirectInfo = () => {
    return history.push("/alerta/consulta-celular/ficha-celular", {
      dados: resultadoCelularImei,
    });
  };

  const handleRedirectInfoVeiculo = () => {
    return history.push("/consulta-veiculo/ficha-veiculo", {
      dados: resultadoVeiculoPlaca,
    });
  };

  function handleRedirectImei(IMEI: string) {
    return history.push("/alerta/consulta-celular/ficha-celular", {
      imei: IMEI,
    });
  }

  return (
    <LayoutConsultasIntegradas>
      <MUI.Grid
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
      >
        {urls.celular ? (
          <MUI.Grid item xs={12} md={3} sm={3}>
            <MUI.TextField
              label="IMEI"
              fullWidth
              size="small"
              value={imei}
              onKeyPress={keyBoardClick}
              onChange={(e) => setImei(e.target.value)}
              disabled={!checkedImei}
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.celular ? (
          <MUI.Grid item xs={12} md={3} sm={3}>
            <MUI.TextField
              label="CHASSI BIKE"
              fullWidth
              size="small"
              value={chassiBike.toUpperCase()}
              onKeyPress={keyBoardClick}
              onChange={(e) => setChassiBike(e.target.value)}
              disabled={!checkedImei}
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.veiculo ? (
          <MUI.Grid xs={12} md={3} sm={3} item>
            <MUI.TextField
              label="PLACA"
              fullWidth
              size="small"
              value={placa.toUpperCase()}
              onKeyPress={keyBoardClick}
              onChange={(e) => setPlaca(e.target.value)}
              disabled={!checkedPlaca}
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.veiculo ? (
          <MUI.Grid xs={12} md={3} sm={3} item>
            <MUI.TextField
              label="CHASSI VEÍCULO"
              fullWidth
              size="small"
              value={chassiVeiculo}
              onKeyPress={keyBoardClick}
              onChange={(e) => setChassiVeiculo(e.target.value)}
              disabled={!checkedPlaca}
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.civil || urls.carcerario ? (
          <MUI.Grid item xs={12} md={3} sm={3}>
            <MUI.TextField
              label="RG"
              fullWidth
              size="small"
              value={rg}
              onKeyPress={keyBoardClick}
              onChange={(e) => setRg(e.target.value)}
              disabled={!checkedCivil && !checkedCarcerario}
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.civil || urls.criminal ? (
          <MUI.Grid xs={12} md={3} sm={3} item>
            <MUI.TextField
              label="CPF"
              fullWidth
              size="small"
              value={cpf}
              onKeyPress={keyBoardClick}
              onChange={(e) => setCpf(e.target.value)}
              disabled={!checkedCivil && !checkedCriminal}
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.civil ||
        urls.criminal ||
        urls.carcerario ||
        /* urls.mandado || */
        urls.celular ? (
          <MUI.Grid item xs={12} md={6} sm={6}>
            <MUI.TextField
              label="NOME"
              fullWidth
              size="small"
              value={nome}
              onKeyPress={keyBoardClick}
              onChange={(e) => setNome(e.target.value)}
              disabled={
                !checkedCivil &&
                !checkedCriminal &&
                !checkedCarcerario &&
                /* !checkedMandado && */
                !checkedImei
              }
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.civil || urls.criminal || urls.carcerario /* || urls.mandado */ ? (
          <MUI.Grid xs={12} md={6} sm={6} item>
            <MUI.TextField
              label="NOME DA MÃE"
              fullWidth
              size="small"
              value={nomeMae}
              onKeyPress={keyBoardClick}
              onChange={(e) => setNomeMae(e.target.value)}
              disabled={
                !checkedCivil &&
                !checkedCriminal &&
                !checkedCarcerario
                /* && !checkedMandado */
              }
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.civil || urls.criminal || urls.carcerario /* || urls.mandado */ ? (
          <MUI.Grid xs={12} md={6} sm={6} item>
            <MUI.TextField
              label="NOME DO PAI"
              fullWidth
              size="small"
              value={nomePai}
              onKeyPress={keyBoardClick}
              onChange={(e) => setNomePai(e.target.value)}
              disabled={
                !checkedCivil &&
                !checkedCriminal &&
                !checkedCarcerario
                /* && !checkedMandado */
              }
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.carcerario /* || urls.mandado */ ? (
          <MUI.Grid xs={12} md={6} sm={6} item>
            <MUI.TextField
              label="VULGO"
              fullWidth
              size="small"
              value={vulgo}
              onKeyPress={keyBoardClick}
              onChange={(e) => setVulgo(e.target.value)}
              disabled={!checkedCarcerario /* && !checkedMandado */}
            />
          </MUI.Grid>
        ) : (
          false
        )}
      </MUI.Grid>
      <MUI.Grid
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
      >
        {urls.civil ? (
          <MUI.Grid xs={12} md={3} sm={3} item>
            <MUI.FormControlLabel
              control={
                <MUI.Checkbox defaultChecked onChange={handleConsultaCivil} />
              }
              label="CIVIL"
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.criminal ? (
          <MUI.Grid xs={12} md={3} sm={3} item>
            <MUI.FormControlLabel
              control={
              (
                <MUI.Checkbox
                  defaultChecked
                  onChange={handleConsultaCriminal}
                />
              )
              }
              label="CRIMINAL"
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.carcerario ? (
          <MUI.Grid xs={12} md={3} sm={3} item>
            <MUI.FormControlLabel
              control={
              (
                <MUI.Checkbox
                  defaultChecked
                  onChange={handleConsultaCarcerario}
                />
              )
              }
              label="CARCERÁRIO"
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {/* {urls.mandado ? (
          <MUI.Grid xs={12} md={3} sm={3} item>
            <MUI.FormControlLabel
              control={
                <MUI.Checkbox defaultChecked onChange={handleConsultaMandado} />
              }
              label="MANDADO"
            />
          </MUI.Grid>
        ) : (
          false
        )} */}

        {urls.veiculo ? (
          <MUI.Grid xs={12} md={3} sm={3} item>
            <MUI.FormControlLabel
              control={
                <MUI.Checkbox defaultChecked onChange={handleConsultaPlaca} />
              }
              label="VEÍCULO"
            />
          </MUI.Grid>
        ) : (
          false
        )}

        {urls.celular ? (
          <MUI.Grid xs={12} md={3} sm={3} item>
            <MUI.FormControlLabel
              control={
                <MUI.Checkbox defaultChecked onChange={handleConsultaImei} />
              }
              label="ALERTA"
            />
          </MUI.Grid>
        ) : (
          false
        )}
      </MUI.Grid>

      <MUI.Grid
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => {
              ConsultaVeiculo();
              ConsultaBike();
              ConsultaImei();
              ConsultaCivil();
              ConsultaCriminal();
              ConsultaCarceraria();
              // ConsultaMandado();
            }}
            disabled={
              loadingCelular ||
              loadingBike ||
              loadingPlaca ||
              loadingCivil ||
              loadingCriminal ||
              loadingCelNome
            }
            startIcon={<Icon.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
        <MUI.Grid item xs={12} md={4} sm={4}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={() => {
              limparConsultaCelularImei();
              limparConsultaBike();
              limparConsultaCivilCPF();
              limparConsultaCivilNominal();
              limparConsultaCivilRg();
              limparConsultaCriminalNominal();
              limparConsultaCriminalCPF();
              limparConsultaVeiculoPlaca();
              limparConsultaVeiculoChassi();
              limparConsultaCarcerarioNominal();
              limparConsultaCarcerarioRG();
              // limparConsultaMandadoNominal();
              limparConsultaCelularNome();
            }}
            disabled={
              loadingCelular ||
              loadingBike ||
              loadingPlaca ||
              loadingCivil ||
              loadingCriminal ||
              loadingCelNome
            }
            startIcon={<Icon.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>
      <ResultadoDaConsulta>
        {(loadingCelular ||
          loadingPlaca ||
          loadingCivil ||
          loadingCriminal ||
          loadingCelNome) && <MUI.LinearProgress />}

        {resultadoCelularImei && (
          <ResultadoConsultaCelular
            situacao={
              resultadoCelularImei?.APARELHO_INFOPOL
                ? resultadoCelularImei.APARELHO_INFOPOL.SITUACAO
                : resultadoCelularImei?.APARELHO_ALERTA?.SITUACAO
            }
            imei={
              resultadoCelularImei?.APARELHO_INFOPOL
                ? resultadoCelularImei.APARELHO_INFOPOL.IMEIS.join(" // ")
                : resultadoCelularImei?.APARELHO_ALERTA?.IMEI
            }
            marca={
              resultadoCelularImei?.APARELHO_INFOPOL
                ? resultadoCelularImei.APARELHO_INFOPOL.MARCA
                : resultadoCelularImei?.APARELHO_ALERTA?.MARCA
            }
            modelo={
              resultadoCelularImei?.APARELHO_INFOPOL
                ? resultadoCelularImei.APARELHO_INFOPOL.MODELO
                : resultadoCelularImei?.APARELHO_ALERTA?.MODELO
            }
            onClick={() => handleRedirectInfo()}
          />
        )}
        {resultadoCelularNome &&
          resultadoCelularNome.map((resultado) => (
            <ResultadoConsultaCelular
              key={resultado.IMEI}
              situacao={
                resultado.SITUACAOALERTA === 0 ? "NÃO ALERTADO" : "ALERTADO"
              }
              imei={resultado.IMEI}
              marca={resultado.MARCA}
              modelo={resultado.MODELO}
              onClick={() => handleRedirectImei(resultado.IMEI)}
            />
          ))}

        {resultadoBike &&
          resultadoBike?.map((bike) => (
            <ResultadoConsultaBike
              situacao={bike.NM_SITUACAO}
              marca={bike.MARCA}
              chassi={bike.CHASSI}
              to={`alerta/consulta-bike/ficha-bike/${bike.CHASSI}/${bike.MARCA}/${bike.ID_BIKE}`}
            />
          ))}

        {resultadoCivilNominal &&
          resultadoCivilNominal?.map((cidadao) => (
            <ResultadoConsultaCivil
              key={cidadao.NumeroPedido}
              infoName={cidadao.Nome}
              infoMae={cidadao.Mae}
              infoPai={cidadao.Pai}
              to={`consulta-civil/ficha-civil/${cidadao.NumeroPessoa}`}
            />
          ))}

        {resultadoCivilCPF &&
          resultadoCivilCPF?.map((cidadao) => (
            <ResultadoConsultaCivil
              key={cidadao.NumeroPedido}
              infoName={cidadao.Nome}
              infoMae={cidadao.Mae}
              infoPai={cidadao.Pai}
              to={`consulta-civil/ficha-civil/${cidadao.NumeroPessoa}`}
            />
          ))}

        {resultadoCivilRg &&
          resultadoCivilRg?.map((cidadao) => (
            <ResultadoConsultaCivil
              key={cidadao.NumeroPedido}
              infoName={cidadao.Nome}
              infoMae={cidadao.Mae}
              infoPai={cidadao.Pai}
              to={`consulta-civil/ficha-civil/${cidadao.NumeroPessoa}`}
            />
          ))}

        {resultadoCriminalNominal &&
          resultadoCriminalNominal?.map((cidadao) => (
            <ResultadoConsultaCriminal
              key={cidadao.NumeroPedido}
              infoNome={cidadao.Nome}
              infoMae={cidadao.Mae}
              infoPai={cidadao.Pai}
              to={`consulta-criminal/ficha-criminal/${cidadao.NumeroPessoa}`}
            />
          ))}

        {resultadoCriminalCPF &&
          resultadoCriminalCPF?.map((cidadao) => (
            <ResultadoConsultaCriminal
              key={cidadao.NumeroPedido}
              infoNome={cidadao.Nome}
              infoMae={cidadao.Mae}
              infoPai={cidadao.Pai}
              to={`consulta-criminal/ficha-criminal/${cidadao.NumeroPessoa}`}
            />
          ))}

        {resultadoCarcerarioNominal &&
          resultadoCarcerarioNominal?.map((cidadao) => (
            <ResultadoConsultaCarcerario
              key={cidadao.DET_ID}
              situacao={cidadao.SITUACAO}
              infoNome={cidadao.DET_NOME}
              vulgo={cidadao.DET_NOMEVULGO}
              infoMae={cidadao.DET_NOMEMAE}
              infoPai={cidadao.DET_NOMEPAI}
              to={`consulta-carcerario/ficha-carcerario/${cidadao.DET_ID}`}
            />
          ))}

        {resultadoCarcerarioRG &&
          resultadoCarcerarioRG?.map((cidadao) => (
            <ResultadoConsultaCarcerario
              key={cidadao.DET_ID}
              situacao={cidadao.SITUACAO}
              infoNome={cidadao.DET_NOME}
              vulgo={cidadao.DET_NOMEVULGO}
              infoMae={cidadao.DET_NOMEMAE}
              infoPai={cidadao.DET_NOMEPAI}
              to={`consulta-carcerario/ficha-carcerario/${cidadao.DET_ID}`}
            />
          ))}

        {/* {resultadoMandadoNominal &&
          resultadoMandadoNominal?.map((cidadao) => (
            <ResultadoConsultaMandado
              key={cidadao.CADASTRO}
              infoNome={cidadao.NOME1}
              vulgo={cidadao.VULGO1}
              infoMae={cidadao.NOMEMAE}
              infoPai={cidadao.NOMEPAI}
              to={`consulta-mandado/ficha-mandado/${cidadao.CADASTRO}`}
            />
          ))} */}

        {resultadoVeiculoPlaca && (
          <ResultadoConsultaVeiculoPlaca
            nome={resultadoVeiculoPlaca.Nome}
            placa={resultadoVeiculoPlaca.Placa}
            chassi={resultadoVeiculoPlaca.Chassi}
            onClick={() => handleRedirectInfoVeiculo()}
          />
        )}

        {resultadoVeiculoChassi && (
          <ResultadoConsultaVeiculoPlaca
            nome={resultadoVeiculoChassi.Nome}
            placa={resultadoVeiculoChassi.Placa}
            chassi={resultadoVeiculoChassi.Chassi}
            onClick={() => handleRedirectInfo()}
          />
        )}
      </ResultadoDaConsulta>
    </LayoutConsultasIntegradas>
  );
};
